import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import CustomGameHttps from "../../../Https/CustomGameHttps";
import ProfileModel from "../../Profile/Models/ProfileModel";
import Profile from "../../Profile/Profile";
import EventGameFilters from "../Models/Filters/EventGameFilters";
import EventGamePredictionsFilters from "../Models/Filters/EventGamePredictionsFilters";
import EventGameRankingsFilters from "../Models/Filters/EventGameRankingsFilters";
import EventGamePredictionRequestBody from "../Models/Prediction/RequestBody/EventGamePredictionRequestBody";
import EventGameValidator from "../Validator/EventGameValidator";

export default class EventGameFacade {
  private https: CustomGameHttps = null;
  private validator: EventGameValidator = null;
  private profile: Profile = null;

  constructor(config: SDKConfigurationModel) {
    this.https = new CustomGameHttps(config);
    this.profile = new Profile(config);
    this.validator = new EventGameValidator(config.errorHandlingMode);
  }

  public getGames = async (
    filters: EventGameFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new EventGameFilters(filters);
    }

    return await this.https.getEventGames(filters, disableCache);
  };

  public getGameById = async (gameId: string, disableCache: boolean) => {
    return await this.https.getEventGameById(gameId, disableCache);
  };

  public makePrediction = async (
    gameId: string,
    prediction: EventGamePredictionRequestBody
  ) => {
    this.validator.validatePrediction(prediction);

    return await this.https.makeEventGamePrediction(gameId, prediction);
  };

  public updatePrediction = async (
    gameId: string,
    predictionId: string,
    prediction: EventGamePredictionRequestBody
  ) => {
    this.validator.validatePrediction(prediction);

    return await this.https.updateEventGamePrediction(
      gameId,
      predictionId,
      prediction
    );
  };

  public getGamePredictionsForUser = async (
    gameId: string,
    profileId: string,
    filters: EventGamePredictionsFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new EventGamePredictionsFilters(filters);
    }

    const data = await this.https.getEventGamePredictionsForUser(
      gameId,
      profileId,
      filters,
      disableCache
    );

    let profileModel = null;

    try {
      profileModel = await this.profile.getById(profileId).getInfo();
    } catch (error) {
      console.error(error);
    }

    data.data.forEach((prediction) => {
      prediction.profileModel = profileModel;
    });

    return data;
  };

  public getRankings = async (
    gameId: string,
    filters: EventGameRankingsFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new EventGameRankingsFilters(filters);
    }

    const response = await this.https.getEventGameRankings(
      gameId,
      filters,
      disableCache
    );
    const profileIds = response.data.map((d) => d.profileId);
    let profiles: ProfileModel[] = [];

    if (profileIds.length > 0) {
      profiles = await this.profile.getByIds(profileIds);
      response.data = response.data.map((d) => {
        d.profileModel = profiles.find((p) => p.id === d.profileId) || null;

        return d;
      });
    }

    return response;
  };
}
